module.exports = __webpack_public_path__ + "img/Megazone.7afc2415.svg";